export class AwsEc2InstanceRestoreResult {
    'instanceId';
    'volumeId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "instanceId",
            "baseName": "instanceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "volumeId",
            "baseName": "volumeId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsEc2InstanceRestoreResult.attributeTypeMap;
    }
    constructor() {
    }
}
